import React, { useState } from "react";
import Select from "react-select";
import {Search} from 'lucide-react';
import classes from "./LoanAccount.module.css"
import plus from "../../../Assets/plus.svg"
import EyeIcon from "../../../Assets/new-eye.svg"
import DeleteIcon from "../../../Assets/new-delete.svg"
import PencilIcon from "../../../Assets/pencil.svg"
import { MdOutlineRemoveRedEye } from "react-icons/md";
import { RiDeleteBinLine } from "react-icons/ri";
import { Spinner, Badge, Button, Modal, Form } from 'react-bootstrap';
import CurrencyInput from 'react-currency-input-field';
import HeaderNav from "../../Accoungting/HeaderNav/HeaderNav";




const loans = [
  { sn: 1, code: "651211", description: "LOAN", reportTo: "IMPAIRMENT OF RECEIVABLES" },
  { sn: 2, code: "012987", description: "CAR LOAN", reportTo: "CAR ADVANCES" },
  { sn: 3, code: "981236", description: "RENT LOAN", reportTo: "RENT ADVANCES" },
  { sn: 4, code: "23412", description: "EMERGENCY LOAN", reportTo: "RENT ADVANCES" },
  { sn: 5, code: "12345", description: "STAFF LOAN", reportTo: "LOAN TO STAFF" },
  { sn: 6, code: "456321", description: "STUDENT LOAN", reportTo: "LOAN TO PARISH/AREA" },
  { sn: 7, code: "789043", description: "SALARY LOAN", reportTo: "AREA & PROVINCE REMITABLES" },
  { sn: 8, code: "00256", description: "SALARY LOAN", reportTo: "AREA & PROVINCE REMITABLES" },
  { sn: 9, code: "09383", description: "School Office", reportTo: "BANK CHARGES" },
  { sn: 10, code: "53672", description: "Emergency Stuff", reportTo: "SUBSCRIPTION & DONATIONS" },
];



const LoanAccount = () => {
    const [selectedOption, setSelectedOption] = useState(null);
    const [searchTerm,setSearchTerm] = useState("");
    const [show, setShow] = useState(false);
    const [loanCode, setLoanCode] = useState("");
  const [loanDescription, setLoanDescription] = useState("");
  const [selectedReportTo, setSelectedReportTo] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [show1, setShow1] = useState(false);

const handleShow1 = (loan) => {
  setLoanCode(loan.code);
  setLoanDescription(loan.description);
  setSelectedReportTo(loan.reportTo); 
  setShow1(true);
};

const handleClose1 = () => setShow1(false);


const handleShow = () => setShow(true);
const handleClose = () => setShow(false);

    const handleChange = (option) => {
            setSelectedOption(option);
            console.log("Selected:", option);
        };
    function getLoanColors(name) {
  let hash = 0;
  for (let i = 0; i < name.length; i++) {
    hash = name.charCodeAt(i) + ((hash << 5) - hash);
  }
  const hue = Math.abs(hash) % 360;

  return {
    backgroundColor: `hsl(${hue}, 70%, 90%)`, 
    color: `hsl(${hue}, 70%, 30%)`,   
  };
}


        
  return (
    <div >
        <HeaderNav />
      
        <Modal show={show} onHide={handleClose} animation={false}>
  <Modal.Header closeButton>
    <Modal.Title>Create loan Account</Modal.Title>
  </Modal.Header>
      <Modal.Body>
        <Form>
          <Form.Group className="mb-3">
            <Form.Label style={{ marginTop: 20 }}>Loan Code</Form.Label>
            <Form.Control
              type="text"
              placeholder="Enter Loan Code"
              value={loanCode}
              onChange={(e) => setLoanCode(e.target.value)}
            />

            <Form.Label style={{ marginTop: 20 }}>Description</Form.Label>
            <Form.Control
              type="text"
              placeholder="Enter Description"
              value={loanDescription}
              onChange={(e) => setLoanDescription(e.target.value)}
            />

            <Form.Label style={{ marginTop: 20 }}>Account Receivables</Form.Label>
            <Select
              loading={isLoading}
            //   options={accRec}
              onChange={setSelectedReportTo}
              value={selectedReportTo}
              placeholder="Select Account Receivables"
              styles={{ container: (base) => ({ ...base, marginTop: 5 }) }}
            />
          </Form.Group>
        </Form>
      </Modal.Body>

  <Modal.Footer>
    <Button variant="danger" onClick={handleClose}>
      Go back
    </Button>
    <Button className={classes.customButton} onClick={"createAccount"}>
    Create
    </Button>
    {/* <Button variant="success" onClick={"createAccount"}>
      {loanLoading ? (
        <>
          <Spinner size="sm" />
          <span style={{ marginLeft: "5px" }}>Creating account, Please wait...</span>
        </>
      ) : (
        "Create"
      )}
    </Button> */}
  </Modal.Footer>
</Modal>
<Modal show={show1} onHide={handleClose1} animation={false}>
  <Modal.Header closeButton>
    <Modal.Title>Update Loan Accounts</Modal.Title>
  </Modal.Header>
  <Modal.Body>
    <Form>
      <Form.Group className="mb-3">
        <Form.Label style={{ marginTop: 20 }}>Loan Code</Form.Label>
        <Form.Control
          type="text"
          placeholder="Enter Loan Code"
          value={loanCode}
          onChange={(e) => setLoanCode(e.target.value)}
        />

        <Form.Label style={{ marginTop: 20 }}>Description</Form.Label>
        <Form.Control
          type="text"
          placeholder="Enter Description"
          value={loanDescription}
          onChange={(e) => setLoanDescription(e.target.value)}
        />

        <Form.Label style={{ marginTop: 20 }}>Balance</Form.Label>
        <CurrencyInput
          name="balance"
          decimalsLimit={2}
          className="form-control"
        //   value={balance}
        //   onValueChange={handleValueChange}
          style={{ textAlign: "right", border: "1px solid #e4e4e4", backgroundColor: "none" }}
        />

        <Form.Label style={{ marginTop: 20 }}>Account Receivables</Form.Label>
        <Select
          loading={isLoading}
        //   options={accRec}
          onChange={setSelectedReportTo}
          value={selectedReportTo}
          placeholder="Select Account Receivables"
        />

        <Form.Label style={{ marginTop: 20 }}>Account Payables</Form.Label>
        <Select
          loading={isLoading}
        //   options={accPay}
        //   onChange={setSelectedPayables}
        //   value={selectedPayables}
          placeholder="Select Account Payables"
        />
      </Form.Group>
    </Form>
  </Modal.Body>
  <Modal.Footer>
    <Button variant="danger" onClick={handleClose1}>
      Go back
    </Button>
    <Button className={classes.customButton} onClick={"editLoan"}>
     Save Changes
    </Button>
    {/* <Button variant="success" onClick={editLoan}>
      {loanLoading ? <Spinner id="loader" animation="border" variant="warning" /> : 'Save Changes'}
    </Button> */}
  </Modal.Footer>
</Modal>


        <div className={classes.topContainer}>
          <div className={classes.topNavBars}>
            <Button className={classes.buttonsNav}>Remitances</Button>
            <Button className={classes.buttonsNav}>Petty Cash</Button>
            <Button className={classes.buttonsNav}>Supplier's Payment</Button>
            <Button className={classes.buttonsNav}>Customer's Leger</Button>
          </div>
          <div style={{marginTop: 24}}/>
            <h3 className={classes.topText}>Loan Account</h3>
            <p className={classes.prgText}>Add, Upload, View, Edit, and Delete Loan Account.</p>
            <div className={classes.subContainer}>
                <div className={classes.searchInputWrapper}>
                                <input
                                    type="text"
                                    value={searchTerm}
                                    onChange={(e) => setSearchTerm(e.target.value)}
                                    className={classes.searchInput}
                                    placeholder="Search accounts..."
                                />
                                <Search className={classes.searchIcon} size={16} />
                            </div>
                            <div className={classes.statCount}>
                              <div className={classes.statConn}>
                              <p className={classes.txtHd}>Loan Accounts</p>
                              <p className={classes.txtHds}>9</p>
                              </div>
                            </div>
                            <div>
  <button className={classes.loanBtn} onClick={handleShow}>
    <img src={plus} alt="plus" /> Create Loan Account
  </button>
</div>

            </div>
            <div className={classes.tableContainer}>
          <table className={classes.tableTable}>
  <thead className={classes.tableHeader}>
    <tr>
      <th>#</th>
      <th>Code</th>
      <th>Description</th>
      <th>Report To</th>
      <th>Action</th>
    </tr>
  </thead>
  <tbody>
    {loans.map((loan) => (
      <tr key={loan.sn}>
        <td className={classes.textby}>{loan.sn}</td>
        <td className={classes.textby}>{loan.code}</td>
       <td className={classes.textby}>
  <span
    className={classes.statucColor}
    style={getLoanColors(loan.description)}
  >
    {loan.description}
  </span>
</td>


        <td className={classes.textby}>{loan.reportTo}</td>
        <td className={classes.btnAction}>
          <button
  style={{ backgroundColor: "transparent", border: 0, cursor: "pointer" }}
  onClick={() => handleShow1(loan)} 
>
  <img src={EyeIcon}/>
</button>
          <button
  style={{ backgroundColor: "transparent", border: 0, cursor: "pointer" }}
  onClick={() => handleShow1(loan)} 
>
  <img src={PencilIcon}/>
</button>

          <button
            style={{ backgroundColor: "transparent", border: 0, cursor: "pointer" }}
          >
            <img src={DeleteIcon}/>
          </button>
        </td>
      </tr>
    ))}
  </tbody>
</table>
<div className={classes.paginationStyle}>
  <div className={classes.footerSubOne}>
    <button className={classes.btnFirst}>First</button>
    
    <span className={classes.ftOne}>
      <button className={`${classes.pageNumber} ${classes.active}`}>1</button>
      <button className={classes.pageNumber}>2</button>
    </span>

    <button className={classes.btnSec}>Last</button>
  </div>
  <p className={classes.displayPag}>Displaying 1-41 of 41</p>
</div>



            </div>
        </div>
    </div>
  )
}

export default LoanAccount